import styled, { css } from 'styled-components';
import { lighten } from 'polished';

export const StyledHeader = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    height: 5.9rem;
    background-color: ${({ theme }) => theme.color.base.dark};

    @media (min-width: 64rem) {
        height: 9.6rem;
    }
`;

export const StyledHeaderLayout = styled.div`
    display: grid;
    grid-template-columns: 30% 40% 30%;
    width: 100%;

    @media (min-width: 64rem) {
        grid-template-columns: repeat(3, 1fr);
    }
`;

export const StyledMenuButton = styled.button<{ expanded: boolean }>`
    ${({ theme, expanded }) => css`
        display: flex;
        padding: 0.4rem 1rem;
        margin: 1rem 0 1rem -1.2rem;
        font-size: 1.6rem;
        font-weight: 400;
        text-align: center;
        line-height: 2.7rem;
        background: none;
        border: 0.2rem solid ${theme.color.base.dark};
        border-radius: 0.8rem;
        outline: none;
        transition: all 0.08s ease-in-out;
        transition-property: background-color, border-color;

        svg {
            height: 2rem;
            margin: 0.35rem 0.8rem 0.35rem 0;
        }

        @media (min-width: 64rem) {
            min-width: 10.7rem;
            padding: 0.6rem 1.3rem;
            margin: 2.55rem 0rem 2.55rem -1.2rem;
            font-size: 1.8rem;
        }

        color: #ffffff;
        &:hover,
        &:focus {
        }

        &:hover {
            background: ${lighten(0.04, theme.color.base.main)};
            border-color: ${theme.color.primary.main};
            cursor: pointer;
        }

        /* Must be duplicated from hover until Safari supports focus-visible */
        &:focus-visible {
            background: ${lighten(0.04, theme.color.base.main)};
            border-color: ${theme.color.primary.main};
        }

        /* Avoid duplicating button border */
        &:focus {
            outline: none;
        }

        ${expanded &&
        css`
            background-color: ${theme.color.secondary.main};
            border-color: ${theme.color.secondary.main};

            &:hover {
                background-color: ${theme.color.secondary.main};
                border-color: ${theme.color.text.main};
            }

            /* Must be duplicated from hover until Safari supports focus-visible */
            &:focus-visible {
                background-color: ${theme.color.secondary.main};
                border-color: ${theme.color.text.main};
            }
        `};
    `}
`;

export const StyledNavigationMenu = styled.nav<{ expanded: boolean }>`
    ${({ expanded }) => css`
        position: fixed;
        top: 5.9rem;
        right: 0;
        bottom: 0;
        left: 0;
        padding: 3.2rem 0;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.4s, visibility 0.4s;
        backdrop-filter: blur(0.4rem);

        @media (min-width: 64rem) {
            top: 9.6rem;
        }

        ${expanded &&
        css`
            visibility: visible;
            opacity: 1;
        `}
    `}
`;

export const StyledNavigationBackground = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    opacity: 0.6;
    background-color: ${({ theme }) => theme.color.base.dark};
`;

export const StyledNavigationContent = styled.div`
    position: relative;
    z-index: 3;

    ul {
        padding-left: 0;
        margin-top: 0;
        margin-bottom: 1.6rem;
    }
`;

export const StyledPrimaryLi = styled.li`
    padding: 2.4rem 0 0.8rem;
    font-size: 3.2rem;
    font-weight: 300;
    line-height: 2.4rem;
    letter-spacing: -0.2rem;
    list-style: none;

    @media (min-width: 64rem) {
        font-size: 4rem;
        line-height: 3.2rem;
    }
`;

export const StyledSecondaryLi = styled.li`
    list-style: none;
    padding: 1.6rem 0 0;
    font-weight: 500;
`;

export const StyledNavigationA = styled.a`
    color: white;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
        text-underline-offset: 0.4rem;
        text-decoration-thickness: from-font;
    }
`;

export const StyledMiddleSection = styled.div`
    display: flex;
    justify-content: center;
`;

export const StyledLogoContainer = styled.div`
    display: flex;
    height: 4.3rem;
    margin: 0.8rem 0;
    cursor: pointer;

    @media (min-width: 64rem) {
        height: 7.5rem;
        margin: 1.05rem 0;
    }
`;
